import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import httpService from "../../../services/httpServices/httpServices";
import helperNumbers from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import helperSpinner from "../../../helpers/spinner";
import StatePositionConstant from "./StatePositionConstant";

export default function ReportPosition() {
  const [reportPosition, setReportPosition] = useState();

  const getReportPosition = async () => {
    const positionTagHtmlID = document
      .querySelector("#tag-html-id")
      .value.trim();

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let reportPosition = await sendRequestGetReportPosition(positionTagHtmlID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!reportPosition) {
      return;
    }

    setReportPosition(reportPosition);
  };

  const sendRequestGetReportPosition = async (positionTagHtmlID) => {
    const headersRequest = getHeaderRequest();
    let positionReport;
    try {
      positionReport = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          `/v1/publisher/position/${positionTagHtmlID}/status`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return positionReport.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getBadgeTypeClassStatePosition = (statePosition) => {
    let classNameBadgeType;
    switch (statePosition) {
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.PENDING
      ]:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.REJECT_FROM_OPERATOR
      ]:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.SEND_SUGGESTION_TO_PUBLISHER
      ]:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.DISAGREE_FROM_PUBLISHER
      ]:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.AGREE_FROM_PUBLISHER
      ]:
        classNameBadgeType = "primary";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.CONFIRM
      ]:
        classNameBadgeType = "success";
        break;

      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.ALREADY_CONFIRMED_PENDING_FOR_EDIT
      ]:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition
          .ALREADY_CONFIRMED_REJECT_FROM_OPERATOR_FOR_EDIT
      ]:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition
          .ALREADY_CONFIRMED_SEND_SUGGESTION_TO_PUBLISHER_FOR_EDIT
      ]:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition
          .ALREADY_CONFIRMED_DISAGREE_SUGGESTION_FROM_PUBLISHER_FOR_EDIT
      ]:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition
          .ALREADY_CONFIRMED_AGREE_SUGGESTION_FROM_PUBLISHER_FOR_EDIT
      ]:
        classNameBadgeType = "primary";
        break;
    }
    return classNameBadgeType;
  };

  const generateReportPositionCampaignActive = () => {
    let campaignIDSActive = reportPosition.campaign_IDS_active;
    return (
      <>
        <hr />
        <h4 className="text text-danger">
          کمپین های در حالت فعال برای این جایگاه
        </h4>
        <table className="table table-hilite tbl-td-white-space">
          <thead>
            <tr>
              <td>شماره</td>
              <td>تاریخ شروع</td>
              <td>تاریخ پایان</td>
            </tr>
          </thead>
          <tbody>
            {campaignIDSActive.map((item, index) => {
              return (
                <tr>
                  <td>{helperNumbers.toPersianNum(index + 1)}</td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.start_date) +
                        " 00:00"
                    )}
                  </td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.end_date) +
                        " 23:59"
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <hr />
      </>
    );
  };

  const generateReportPositionCampaignPending = () => {
    let campaignIDSPending = reportPosition.campaign_IDS_pending;
    return (
      <>
        <hr />
        <h4 className="text text-warning">
          کمپین های در حال انتظار برای این جایگاه
        </h4>
        <table className="table table-hilite tbl-td-white-space">
          <thead>
            <tr>
              <td>شماره</td>
              <td>تاریخ شروع</td>
              <td>تاریخ پایان</td>
            </tr>
          </thead>
          <tbody>
            {campaignIDSPending.map((item, index) => {
              return (
                <tr>
                  <td>{helperNumbers.toPersianNum(index + 1)}</td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.start_date) +
                        " 00:00"
                    )}
                  </td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.end_date) +
                        " 23:59"
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <hr />
      </>
    );
  };

  const generateReportPositionCampaignActiveAlternative = () => {
    let campaignIDSPending = reportPosition.campaign_IDS_active_alternative;
    return (
      <>
        <hr />
        <h4 className="text text-warning">
          کمپین های جایگزین فعال برای این جایگاه
        </h4>
        <table className="table table-hilite tbl-td-white-space">
          <thead>
            <tr>
              <td>شماره</td>
              <td>تاریخ شروع</td>
              <td>تاریخ پایان</td>
            </tr>
          </thead>
          <tbody>
            {campaignIDSPending.map((item, index) => {
              return (
                <tr>
                  <td>{helperNumbers.toPersianNum(index + 1)}</td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.start_date) +
                        " 00:00"
                    )}
                  </td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.end_date) +
                        " 23:59"
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <hr />
      </>
    );
  };

  const generateReportPositionCampaignPendingAlternative = () => {
    let campaignIDSPendingAlternative =
      reportPosition.campaign_IDS_pending_alternative;
    return (
      <>
        <hr />
        <h4 className="text text-warning">
          کمپین های جایگزین در حال انتظار برای این جایگاه
        </h4>
        <table className="table table-hilite tbl-td-white-space">
          <thead>
            <tr>
              <td>شماره</td>
              <td>تاریخ شروع</td>
              <td>تاریخ پایان</td>
            </tr>
          </thead>
          <tbody>
            {campaignIDSPendingAlternative.map((item, index) => {
              return (
                <tr>
                  <td>{helperNumbers.toPersianNum(index + 1)}</td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.start_date) +
                        " 00:00"
                    )}
                  </td>
                  <td className="number-finance" dir="ltr">
                    {helperNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(item.end_date) +
                        " 23:59"
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <hr />
      </>
    );
  };

  const generateTagHtmlReportPosition = () => {
    return (
      <div>
        <div>
          {reportPosition.campaign_IDS_active.length !== 0 ? (
            generateReportPositionCampaignActive()
          ) : (
            <p className="alert alert-primary">
              این جایگاه هیچ کمپین در حالت فعال ندارد
            </p>
          )}
        </div>
        <div>
          {reportPosition.campaign_IDS_pending.length !== 0 ? (
            generateReportPositionCampaignPending()
          ) : (
            <p className="alert alert-primary">
              این جایگاه هیچ کمپین در حالت انتظار ندارد
            </p>
          )}
        </div>
        <div>
          {reportPosition.campaign_IDS_active_alternative.length !== 0 ? (
            generateReportPositionCampaignActiveAlternative()
          ) : (
            <p className="alert alert-primary">
              این جایگاه هیچ کمپین جایگزین در حالت فعال ندارد{" "}
            </p>
          )}
        </div>
        <div>
          {reportPosition.campaign_IDS_pending_alternative.length !== 0 ? (
            generateReportPositionCampaignPendingAlternative()
          ) : (
            <p className="alert alert-primary">
              این جایگاه هیچ کمپین جایگزین در حالت انتظار ندارد
            </p>
          )}
        </div>
        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td
                  colSpan={2}
                  className="text-center"
                  style={{ borderRadius: "25px 25px 0 0" }}
                >
                  اطلاعات جایگاه
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>شماره جایگاه</td>
                <td>{helperNumbers.toPersianNum(reportPosition.id)}</td>
              </tr>
              <tr>
                <td>شماره صفحه</td>
                <td>
                  {reportPosition.page_id == 0
                    ? "مستقل"
                    : helperNumbers.toPersianNum(reportPosition.page_id)}
                </td>
              </tr>
              <tr>
                <td>آدرس صفحه</td>
                <td dir="ltr" className="text-left ">
                  <span className="pr-2">{reportPosition.website_url}</span>
                  <a
                    target="_blank"
                    className="btn btn-primary"
                    href={reportPosition.website_url}
                  >
                    <i className="fa fa-link"></i>
                  </a>
                </td>
              </tr>
              <tr>
                <td>الگو صفحه</td>
                <td>
                  {reportPosition.pattern_url == "0" ? (
                    <span>مستقل</span>
                  ) : (
                    <div dir="ltr" className="text-left ">
                      {reportPosition.pattern_url}
                    </div>
                  )}
                </td>
              </tr>
              <tr>
                <td>اندازه</td>
                <td>
                  <span>ارتفاع = </span>
                  <span>
                    {helperNumbers.toPersianNum(
                      reportPosition.size.split("-")[1]
                    )}
                  </span>
                  <span className="px-3">عرض = </span>
                  <span>
                    {helperNumbers.toPersianNum(
                      reportPosition.size.split("-")[0]
                    )}
                  </span>
                </td>
              </tr>
              <tr>
                <td>تعداد بنر</td>
                <td>{helperNumbers.toPersianNum(reportPosition.count)}</td>
              </tr>
              <tr>
                <td>قیمت پایه جایگاه</td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helperNumbers.toPersianNum(
                      helperNumbers.toFormatFinanceNumber(
                        reportPosition.base_price
                      )
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
              </tr>
              <tr>
                <td>قیمت جایگاه یک بنر در یک شبانه روز</td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helperNumbers.toPersianNum(
                      helperNumbers.toFormatFinanceNumber(reportPosition.price)
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
              </tr>
              <tr>
                <td>حق نمایش دهنده </td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helperNumbers.toPersianNum(
                      helperNumbers.toFormatFinanceNumber(
                        reportPosition.publisher_right
                      )
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
              </tr>
              <tr>
                <td>کمیسیون هایلات</td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helperNumbers.toPersianNum(
                      helperNumbers.toFormatFinanceNumber(
                        reportPosition.hilite_commission
                      )
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
              </tr>
              <tr>
                <td>Hicoin</td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helperNumbers.toPersianNum(
                      helperNumbers.toFormatFinanceNumber(
                        reportPosition.score_alternative
                      )
                    )}
                  </span>
                </td>
              </tr>

              <tr>
                <td>وضعیت</td>
                <td>
                  <span
                    className={` badge badge-${getBadgeTypeClassStatePosition(
                      reportPosition.state
                    )} `}
                  >
                    {reportPosition.state}
                  </span>
                </td>
              </tr>

              <tr>
                <td>حالت</td>
                <td>
                  <div dir="ltr">
                    {reportPosition.active ? (
                      <span className="badge badge-success">فعال</span>
                    ) : (
                      <span className="badge badge-danger">غیرفعال</span>
                    )}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar activeItem="report-position" />

      <div className="content-wrapper">
        <TitleBar title="گزارش جایگاه" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  getReportPosition();
                }}
                className="d-flex align-items-end"
              >
                <div className="form-group flex-grow-1">
                  <label>تگ شناسه html جایگاه</label>
                  <span dir="ltr">( hilite-position- )</span>
                  <input
                    type="text"
                    className="form-control"
                    id="tag-html-id"
                    placeholder="تگ شناسه html جایگاه"
                    required
                  />
                </div>
                <div className="form-group pr-2">
                  <button className="btn btn-primary" id="show-information">
                    نمایش گزارش جایگاه
                  </button>
                </div>
              </form>
              {reportPosition && generateTagHtmlReportPosition()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
